import { Component, OnInit } from '@angular/core';
import { CoreService } from '../../../../../service/core.service';
import { ApiService } from '../../../../../service/api.service';
import * as XLSX from 'xlsx';
import { TranslateService,LangChangeEvent } from '@ngx-translate/core';
import { ExcelService } from '../../../../../service/excel.service';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-inv-due-rec-summary',
  templateUrl: './inv-due-rec-summary.component.html',
  styleUrls: ['./inv-due-rec-summary.component.css']
})
export class InvDueRecSummaryComponent implements OnInit {
  fileName = 'inv_due_rec_summary.xlsx';


  pageLoadingImg: boolean;
  summary: any;
  repDate: any;
  total_recpt: any;
  total_rec_amnt: any;

  filter_types = [
    { id: 't', name: 'Today' },
    { id: 'ld', name: 'Last Day' },
    { id: 'lw', name: 'Last week' },
    { id: 'lm', name: 'Last Month' },
    { id: 'ly', name: 'Last Year' },
    { id: 'c', name: 'Custom Date' },
    { id: '', name: 'All' }

  ];

  filter_sort = [
    { id: 'between', name: 'Between' },
    { id: '<', name: '<' },
    { id: '>', name: '>' },
    { id: '=', name: '=' },
    { id: '<=', name: '<=' },
    { id: '>=', name: '>=' },
    { id: '=', name: '=' },
  ];

  pageFrom: any;
  curpage: any;
  lastpage: any;
  totalData: any;
  pgend: boolean;
  pgstart: boolean;
  rec_amnt_filter: any;
  rec_val1: any;
  rec_val2: any;
  rec_no_filter: any;
  recno_val1: any;
  recno_val2: any;
  branch_all: any;
  company: any;
  customer: any;
  supplier: any;
  users: any;
  godowns: any;
  vans: any;
  vanline_all: any;
  exportLoader: boolean;
  branch_display_name: any;
  branch_display_code: any;
  branch_name: any;
  branch_address:any;
  Expsummary: any;
  ExprepDate: any;
  Exptotal_recpt: any;
  Exptotal_rec_amnt: any;
  country_dec: number=2;
  userType: any;
  cur_lang: string;
  ledName: string;

  constructor(private apiService: ApiService, private coreService: CoreService,private translate: TranslateService,private excelService: ExcelService,private currencyPipe: CurrencyPipe) { }

  ngOnInit() {

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.langChange();
    });
    this.langChange();
  

    this.country_dec=this.coreService.setDecimalLength();
    this.branch_display_name = this.coreService.getUserData('branch_disp_name');
    this.branch_name = this.coreService.getUserData('branch_name');
    this.branch_display_code = this.coreService.getUserData('branch_code');
    this.userType = this.coreService.getUserData('user_type');
    this.branch_address = this.coreService.getUserData('branch_address');

    let searchval = new FormData();
    this.summary = [];

    this.apiService.InvoicedueRecSummary(searchval, 1).subscribe((res: any) => {
      this.pageLoadingImg = false;

      // this.show = res['data'];

      this.summary = res['data']['data'];
      this.repDate = res['data'].Date;
      this.total_recpt = res['data']['total_recpt'];
      this.total_rec_amnt = res['data']['total_rec_amnt'];

      // console.log(this.total_recpt);

      this.pageFrom = res['data']['from'];
      this.curpage = res['data']['current_page'];
      this.lastpage = res['data']['last_page'];
      this.totalData = res['data']['total'];
      // console.log(this.totalData);

      this.pgEnd(this.curpage, this.lastpage);
      this.pgStart(this.curpage);
    });
    this.apiService.cur_lang.subscribe(value =>{
      this.cur_lang = value;
    })
    
    

  }
  langChange(){
    this.translate.get(['Common.today', 'Common.last_day','Common.last_week', 'Common.last_maonth','Common.last_yr', 'Common.cust_date','Common.all']).subscribe((res: string) => {    
     
      
      this.filter_types = [
        
    { id: 't', name: res['Common.today'] },
    { id: 'ld', name: res['Common.last_day'] },
    { id: 'lw', name: res['Common.last_week'] },
    { id: 'lm', name: res['Common.last_maonth'] },
    { id: 'ly', name: res['Common.last_yr'] },
    { id: 'c', name: res['Common.cust_date'] },
    { id: '', name: res['Common.all'] }
        
      ];
    });

  }


  pgEnd(curr, end) {
    if (curr == end)
      this.pgend = true;
    else
      this.pgend = false;

  }

  pgStart(curr) {
    if (curr == 1)
      this.pgstart = true;
    else
      this.pgstart = false;
  }


  pageNext(formdata: { value: any; }, pageno: any) {
    this.pageLoadingImg = true;
    if (formdata.value.period_type === 'c') {
      formdata.value.date1 = (formdata.value.date1) ? this.apiService.formatDate(formdata.value.date1) : formdata.value.date1;
      formdata.value.date2 = (formdata.value.date2) ? this.apiService.formatDate(formdata.value.date2) : formdata.value.date2;
      formdata.value.time1 = (formdata.value.time1) ? this.apiService.formatTime(formdata.value.time1) : formdata.value.time1;
      formdata.value.time2 = (formdata.value.time2) ? this.apiService.formatTime(formdata.value.time2) : formdata.value.time2;
    }

    if (formdata.value.inv_period_type === 'c') {
      formdata.value.inv_date1 = (formdata.value.inv_date1) ? this.apiService.formatDate(formdata.value.inv_date1) : formdata.value.inv_date1;
      formdata.value.inv_date2 = (formdata.value.inv_date2) ? this.apiService.formatDate(formdata.value.inv_date2) : formdata.value.inv_date2;
     
    }

    this.summary = [];

    this.apiService.InvoicedueRecSummary(formdata.value, pageno).subscribe((res: any) => {
      this.pageLoadingImg = false;
      // if(res['data']['data']){

      this.summary = res['data']['data'];
      this.repDate = res['data'].Date;
      this.total_recpt = res['data']['total_recpt'];
      this.total_rec_amnt = res['data']['total_rec_amnt'];
      this.pageFrom = res['data']['from'];
      this.curpage = res['data']['current_page'];
      this.lastpage = res['data']['last_page'];
      this.totalData = res['data']['total'];
      // console.log(this.totalData);

      this.pgEnd(this.curpage, this.lastpage);
      this.pgStart(this.curpage);
      // }
    });

  }

  searchBranch(search: string) {
    let searchval = new FormData();
    searchval.append("branch_name", search);
    this.apiService.getBranchByName(searchval).subscribe((res) => {
      this.branch_all = res['data'];
      this.branch_all.push({ 'branch_id': 'All', 'branch_name': 'All Branch', 'branch_display_name': 'All Branch' })
    });
  }

  searchComp(search: string) {
    const searchval = new FormData();
    searchval.append('manftr_comp_name', search);
    this.apiService.getManfbyName(searchval).subscribe((res) => {
      this.company = res['data'];
    });

  }


  searchCustomer(search: string) {
    const searchval = new FormData();
    searchval.append('cust_name', search);
     if(this.cur_lang !=undefined && this.cur_lang !=null && this.cur_lang !='English' ){
      searchval.append("with-alias", "1");
    }
    this.apiService.searchCustomer(searchval).subscribe((res) => {
      this.customer = res['data'];
    });

  }

  searchVanlines(search: string) {
    let searchval = new FormData();
    searchval.append("vanline_name", search);
    this.apiService.getVanlinesName(searchval).subscribe((res) => {
      this.vanline_all = res['data'];

    });
  }

  searchSupplier(search: string) {
    const searchval = new FormData();
    searchval.append('supp_name', search);
    this.apiService.searchSupplier(searchval).subscribe((res) => {
      this.supplier = res['data'];
    });

  }

  searchUser(search: string) {
    let searchval = new FormData();
    searchval.append("usr_name", search);
    this.apiService.getUserByName(searchval).subscribe((res) => {
      this.users = res['data'];
    });
  }

  searchGdwn(search: string) {
    let searchval = new FormData();
    searchval.append("gd_name", search);
    this.apiService.getGodownByName(searchval).subscribe((res) => {
      this.godowns = res['data'];
      this.godowns.push({ "gd_id": 0, 'gd_name': 'All' });
    });

  }

  searchVans(search: string) {
    const searchval = new FormData();
    searchval.append('van_name', search);
    this.apiService.searchVans(searchval).subscribe((res) => {
      this.vans = res['data'];
      this.vans.push({ "van_id": 'All', 'van_name': 'All' });

    });

  }

  exportexcel(): void {
    /* table id is passed over here */
    let element = document.getElementById('export-group');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, this.fileName);
    this.exportLoader = false;

  }


  exportEXCL(Expformdata: { value: any; }) {
    this.exportLoader = true;

    // debugger;
    Expformdata.value.export = 'export';

    if (Expformdata.value.period_type === 'c') {
      Expformdata.value.date1 = (Expformdata.value.date1) ? this.apiService.formatDate(Expformdata.value.date1) : Expformdata.value.date1;
      Expformdata.value.date2 = (Expformdata.value.date2) ? this.apiService.formatDate(Expformdata.value.date2) : Expformdata.value.date2;
    }

    this.Expsummary = [];

    this.apiService.InvoicedueRecSummary(Expformdata.value, 1).subscribe((res: any) => {
      this.pageLoadingImg = false;
      // if(res['data']['data']){

      this.Expsummary = res['data']['data'];
      this.ExprepDate = res['data'].Date;
      this.Exptotal_recpt = res['data']['total_recpt'];
      this.Exptotal_rec_amnt = res['data']['total_rec_amnt'];
      


    setTimeout(() => {
      this.exportexcel();
    }, 3000);


    Expformdata.value.export = '';
  });



}

// pdf download
generatePdf(Expformdata: { value: any; }) {

  this.exportLoader = true;

  // debugger;
  Expformdata.value.export = 'export';

  if (Expformdata.value.period_type === 'c') {
    Expformdata.value.date1 = (Expformdata.value.date1) ? this.apiService.formatDate(Expformdata.value.date1) : Expformdata.value.date1;
    Expformdata.value.date2 = (Expformdata.value.date2) ? this.apiService.formatDate(Expformdata.value.date2) : Expformdata.value.date2;
  }

  this.Expsummary = [];

  this.apiService.InvoicedueRecSummary(Expformdata.value, 1).subscribe((res: any) => {

    // if(res['data']['data']){

    this.Expsummary = res['data']['data'];
    this.ExprepDate = res['data'].Date;
    this.Exptotal_recpt = res['data']['total_recpt'];
    this.Exptotal_rec_amnt = res['data']['total_rec_amnt'];

    console.log(this.Expsummary);
    

    const heads = [
      this.translate.instant('Table.sl_no'),
      this.translate.instant('transaction.Receipt_No'),
      this.translate.instant('transaction.Branch_Receipt_No'),
      this.translate.instant('ACCOUNTS.Vch_No'),
      this.translate.instant('Common.customer_name'),
      this.translate.instant('Common.Inv_Date'),
      this.translate.instant('HOME.Invoice_no'),
      this.translate.instant('transaction.Branch_Inv_No'),
      this.translate.instant('transaction.Rec_Date'),
      this.translate.instant('transaction.Rec_Amount')
    ];
  
      const lblXPos = 10;
      const headerHeight = 15;
      const valueXPos = 55;
      const data = [];
  
      this.Expsummary.forEach((item,index)=>{
        if(this.translate.currentLang == "Arabic"){this.ledName =  item.ledger.ledger_secondName}
        else{this.ledName =  item.ledger.ledger_name}
        data.push([
          index + 1,
          item.recipt_no,
          item.brnch_recpt_num,
          item.vch_no,
          this.ledName,
          item.inv_date,
          item.salesduesub_inv_no,
          item.branch_inv_no,
          item.salesduesub_date,
          (item.salesduesub_in).toFixed(this.country_dec),
        ])
      })
  
      let doc = this.excelService.getPdfObj();
  
      var addressLines = this.branch_address.split('\r\n');
      var addressText = addressLines.join(', ');
  
      doc.setFont('Amiri');
      doc.setFontSize(12);
      doc.text(this.branch_display_name +' ' + '(' + this.branch_display_code + ')', 70, headerHeight - 2);
  
      doc.setFont('Amiri');
      doc.setFontSize(9);
      doc.text(addressText, 71, headerHeight + 2);
  
      if(this.ExprepDate){
        doc.setFontSize(10);
        doc.text(`${this.translate.instant('Common.Duration')}`, lblXPos, headerHeight + 10);
        doc.setFontSize(10);
        doc.text(':  ' + this.ExprepDate.date1 + '   to   ' + this.ExprepDate.date2  ,  valueXPos, headerHeight + 10);
      }
  
      doc.setFontSize(10);
      doc.text(`${this.translate.instant('HOME.REPORT')}`, lblXPos, headerHeight + 15);
      doc.setFontSize(10);
      doc.text(':  ' + `${this.translate.instant('Common.inv_due_rec_summary')}`,  valueXPos, headerHeight + 15);

      doc.setFontSize(10);
      doc.text(`${this.translate.instant('Purchase.total_recpts')}`, lblXPos, headerHeight + 20);
      doc.setFontSize(10);
      doc.text(':  ' + (this.Exptotal_recpt).toFixed(this.country_dec),  valueXPos, headerHeight + 20);

      doc.setFontSize(10);
      doc.text(`${this.translate.instant('Purchase.total_rec_amnt')}`, lblXPos, headerHeight + 25);
      doc.setFontSize(10);
      doc.text(':  ' + (this.Exptotal_rec_amnt).toFixed(this.country_dec),  valueXPos, headerHeight + 25);
      
      doc = this.excelService.addTableToPdf(doc, headerHeight + 30, lblXPos, heads, data, null);
  
     
      doc.save(`Invoice Due Reciept Summary.pdf`);

      Expformdata.value.export = '';

      this.exportLoader = false;
});
  

  
}
 
}
